export default class Errors {
  /**
   * Create a new Errors instance.
   */
  constructor () {
    this.errors = {};
  }

  /**
   * Retrieve the error message for a given field.
   *
   * @param field
   * @returns {{} | undefined}
   */
  get (field) {
    if (!field || !this.errors) {
      return;
    }

    return this.errors.hasOwnProperty(field) ? this.errors[field] : undefined;
  }

  /**
   * Determine if there are any errors
   *
   * @returns {boolean}
   */
  any () {
    return Object.keys(this.errors).length > 0;
  }

  /**
   * Determine if an error exists for the given field
   *
   * @param field
   * @returns {boolean}
   */
  has (field) {
    return !!this.get(field);
  }

  /**
   * Parse the data for errors.
   *
   * @param data
   */
  parse (data) {
    this.errors = {};

    if (data.hasOwnProperty('errors')) {
      this.parseErrors(data.errors);
    }

    return this.errors;
  }

  /**
   * Parse the data for network errors.
   *
   * @param data
   */
  parseNetwork (data) {
    this.errors = {};

    if (data.hasOwnProperty('message')) {
      return this.errors.message = data.message;
    }
  }

  /**
   * Parse the request errors
   *
   * @param dataErrors
   */
  parseErrors (dataErrors) {
    dataErrors.forEach((dataError) => {
      if (!dataError.hasOwnProperty('field') || !dataError.hasOwnProperty('message')) {
        return;
      }

      const field = dataError.field;
      const message = dataError.message;

      if (this.errors.hasOwnProperty(field)) {
        this.errors[field] += `, ${message}`;
      } else {
        this.errors[field] = message;
      }
    });
  }
}
